import { render, staticRenderFns } from "./zhihui.vue?vue&type=template&id=11a3fa0c&scoped=true&"
import script from "./zhihui.vue?vue&type=script&lang=js&"
export * from "./zhihui.vue?vue&type=script&lang=js&"
import style0 from "./zhihui.vue?vue&type=style&index=0&id=11a3fa0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a3fa0c",
  null
  
)

export default component.exports